import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowRight, FiCircle, FiLayers, FiTool, FiSettings } = FiIcons;

const TechnicalSpotlight = () => {
  const spotlights = [
    {
      title: 'Rillenkugellager 6205-2RS',
      description: 'Standardlager für radiale Belastungen mit beidseitiger Dichtung',
      specs: ['Ø 25 x 52 x 15 mm', 'C_dyn: 14,0 kN', 'Dichtung: 2RS'],
      icon: FiCircle,
      category: 'Wälzlager',
      link: '/product/6205-2rs'
    },
    {
      title: 'NBR Wellendichtring',
      description: 'Radialwellendichtring für Standardanwendungen bis 100°C',
      specs: ['25 x 47 x 7 mm', 'Material: NBR', 'Temp: -40°C bis +100°C'],
      icon: FiLayers,
      category: 'Dichtungstechnik',
      link: '/product/nbr-seal'
    },
    {
      title: 'Profilschienenführung HSR25',
      description: 'Hochpräzise Linearführung für Automatisierungsanwendungen',
      specs: ['Baugröße 25', 'C_dyn: 28,0 kN', 'Genauigkeit: N'],
      icon: FiTool,
      category: 'Lineartechnik',
      link: '/product/hsr25'
    },
    {
      title: 'Keilriemen SPA-1500',
      description: 'Schmalkeilriemen für Antriebsanwendungen',
      specs: ['Profil: SPA', 'L_d: 1500 mm', 'Max. Power: 15,5 kW'],
      icon: FiSettings,
      category: 'Antriebstechnik',
      link: '/product/spa-1500'
    }
  ];

  return (
    <motion.div
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Technische Highlights</h2>
          <p className="text-gray-600">Ausgewählte Komponenten aus unserem Sortiment</p>
        </div>
        <Link
          to="/categories"
          className="text-red-600 hover:text-red-700 font-medium flex items-center space-x-1"
        >
          <span>Alle anzeigen</span>
          <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
        </Link>
      </div>

      <div className="space-y-4">
        {spotlights.map((item, index) => (
          <motion.div
            key={item.title}
            className="p-4 border border-gray-200 rounded-lg hover:border-red-200 hover:bg-red-50/30 transition-colors cursor-pointer"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={item.icon} className="w-5 h-5 text-red-600" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 text-base leading-tight mb-1">
                      {item.title}
                    </h3>
                    <span className="inline-block text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded font-medium">
                      {item.category}
                    </span>
                  </div>
                </div>
                
                <p className="text-sm text-gray-600 mb-3 leading-relaxed">
                  {item.description}
                </p>
                
                <div className="space-y-1.5 mb-4">
                  {item.specs.map((spec, i) => (
                    <div key={i} className="flex items-center">
                      <div className="w-1.5 h-1.5 bg-red-400 rounded-full mr-2 flex-shrink-0"></div>
                      <p className="text-xs text-gray-700 font-medium leading-tight">
                        {spec}
                      </p>
                    </div>
                  ))}
                </div>
                
                <Link
                  to={item.link}
                  className="inline-flex items-center space-x-2 text-red-600 hover:text-red-700 text-sm font-medium group"
                >
                  <span>Details anzeigen</span>
                  <SafeIcon icon={FiArrowRight} className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default TechnicalSpotlight;